/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {closeAccount} from '../api'

export const useMutationCloseAccount = createReactQueryMutationHook('closeAccount', closeAccount)
